/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    '{sourceName} 레코드를 모두 찾으려면 검색어(문자 또는 숫자)를 최소 {minimumLength}자 이상 입력하세요.',
  [HintsType.noFilterOrSearchRecordsTitle]: '검색 결과 없음',
  [HintsType.noFilterOrSearchRecordsContent]:
    '다른 소스에서 결과를 확인하거나 키워드를 변경하세요.',
  [HintsType.searching]: '검색하는 중...',
  companyTabTitle: '회사',
  personalTabTitle: '개인',
  direct: '직접',
  extension: '내선',
  contact: '문의하기',
  mobile: '모바일',
  company: '회사',
  home: '홈',
  home2: '홈',
  other: '기타',
  business: '비즈니스',
  business2: '비즈니스',
  car: '자동차',
  fax: '팩스',
  assistant: '도우미',
  callback: '콜백',
  MobileNumber: '휴대폰 번호',
  ContactNumber: '연락처 번호',
  DirectNumber: '직통 번호',
  doNotCall: '발신 금지',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
